<script>
	import router from 'page';
	import { fade } from 'svelte/transition';
	import Navbar from './components/Navbar.svelte';
	import './App.scss';
	import pages from './pages';
  	
	let page_context;
	let page;
	let currentPage = null;
	$: currentUrl = router.current;
	let title = 'The Skill Tree Company';

	function updatePage() {
		currentPage = page;
        window.scrollTo(0, 0);
	}

	function setPage(ctx, new_title, p) {
		page_context = ctx;
		title = 'The Skill Tree Company';		
		if (new_title !== '') {
			title = `${new_title} | The Skill Tree Company`;
		}
		if (currentPage == null) {
			currentPage = p;
		}
		page = p;
		currentUrl = router.current;
	}

	pages.forEach(page => {
		router(page.url, (ctx) => setPage(ctx, page.title, page.component));
	});

	router.start();
</script>

<svelte:head>
	<title>{title}</title>
</svelte:head>

<app>
	<content>
		<Navbar current={currentUrl}></Navbar>
		{#if currentPage === page}
		<div on:outroend={updatePage} transition:fade={{duration: 100}}>
			
			<svelte:component this={currentPage} context={page_context}/>
		</div>
		{/if}
	</content>
	<footer class="footer">
		<div class="content has-text-centered">
			<p>
				<strong>The Skill Tree Company</strong> is a trading name of <strong>The Skill Tree Company Limited</strong>
			</p>
			<p>
				registered in England and Wales; Company registration number 9720583
			</p>
		</div>
		<div class="container">
			<div class="columns">
				<div class="column">
					<div class="subtitle">Pages</div>
					<ul class="content">
						{#each pages as {url, title, navbar_label, hide_in_navbar}}
							{#if !hide_in_navbar}
								<a href="{url}">{navbar_label || title}</a><br/>
							{/if}
						{/each}
					</ul>
				</div>
				<div class="column">
					<div class="subtitle">Social Media</div>
					<div class="content">
						<a href="https://twitter.com/TheSkillTreeCo" target="_blank">
							<span class="icon-text">
								<span class="icon">
									<ion-icon name="logo-twitter"></ion-icon>
								</span>
								<span>Twitter</span>
							</span>
						</a>
						<br>
						<a href="https://facebook.com/theskilltreecompany/" target="_blank">
							<span class="icon-text">
								<span class="icon">
									<ion-icon name="logo-facebook"></ion-icon>
								</span>
								<span>Facebook</span>
							</span>
						</a>
						<br>
						<a href="https://instagram.com/theskilltreeco/" target="_blank">
							<span class="icon-text">
								<span class="icon">
									<ion-icon name="logo-instagram"></ion-icon>
								</span>
								<span>Instagram</span>
							</span>
						</a>
					</div>
				</div>
				<div class="column">
					<div class="subtitle">Policies</div>
					<div class="content">
						<a href="/privacy-policy">Privacy Policy</a>
						<br/>
						<a href="/terms-and-conditions">Website Terms and Conditions</a>
					</div>
				</div>
			</div>
		</div>
	</footer>
</app>

<style>
	app {
		height: 100%;
		display: flex;
		flex-direction: column;
	}

	content {
		flex: 1 0 auto;
	}

	footer.footer {
		flex-shrink: 0;
	}
</style>
